// Working time
class WorkingTime extends HTMLElement {

	#controller = new AbortController();

	connectedCallback() {
		const openingTime = this.dataset.open;   // "09:00"
		const closingTime = this.dataset.close;  // "17:00"

		if (!openingTime || !closingTime) return;

		const now = new Date();
		const nowMinutes = now.getHours() * 60 + now.getMinutes();

		const openMinutes = this.#toMinutes(openingTime);
		const closeMinutes = this.#toMinutes(closingTime);

		const isOpen = this.#isWithinRange(nowMinutes, openMinutes, closeMinutes);

		this.classList.toggle('open', isOpen);
		this.classList.toggle('close', !isOpen);
	}

	#toMinutes(time) {
		const [h, m] = time.split(':').map(Number);
		return h * 60 + m;
	}

	#isWithinRange(now, open, close) {
		// 09:00–17:00
		if (close > open) {
			return now >= open && now < close;
		}

		return now >= open || now < close;
	}

	/**
	 * Handles the disconnect event.
	 */
	disconnectedCallback() {
		// Disconnect all the event listeners
		this.#controller.abort();
	}
}

if (!customElements.get('working-time-component')) {
	customElements.define('working-time-component', WorkingTime);
}
